import { render, staticRenderFns } from "./the-feedback.vue?vue&type=template&id=1ad110c8&"
import script from "./the-feedback.vue?vue&type=script&lang=js&"
export * from "./the-feedback.vue?vue&type=script&lang=js&"
import style0 from "./the-feedback.vue?vue&type=style&index=0&lang=sass&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./the-feedback.vue?vue&type=style&index=0&lang=sass&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./the-feedback.vue?vue&type=style&index=0&lang=sass&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js").rerender("1ad110c8")
            }
          }
        })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad110c8')) {
      api.createRecord('1ad110c8', component.options)
    } else {
      api.reload('1ad110c8', component.options)
    }
    module.hot.accept("./the-feedback.vue?vue&type=template&id=1ad110c8&", function () {
      api.rerender('1ad110c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/the-feedback.vue"
export default component.exports